<div class="container">
  <mat-stepper
    orientation="vertical"
    [linear]="false"
    class="mat-elevation-z8"
    labelPosition="bottom"
    #shareProductStepper
  >
    <ng-template matStepperIcon="number">
      <fa-icon icon="pencil-alt" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="edit">
      <fa-icon icon="pencil-alt" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="done">
      <fa-icon icon="check" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="error">
      <fa-icon icon="exclamation-triangle" size="lg"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="preview">
      <fa-icon icon="eye" size="sm"></fa-icon>
    </ng-template>

    <mat-step [stepControl]="shareProductDetailsForm">
      <ng-template matStepLabel>{{ 'labels.inputs.DETAILS' | translate }}</ng-template>

      <LOSx-share-product-details-step></LOSx-share-product-details-step>
    </mat-step>

    <mat-step [stepControl]="shareProductCurrencyForm">
      <ng-template matStepLabel>{{ 'labels.inputs.CURRENCY' | translate }}</ng-template>

      <LOSx-share-product-currency-step
        [shareProductsTemplate]="shareProductsTemplate"
      ></LOSx-share-product-currency-step>
    </mat-step>

    <mat-step [stepControl]="shareProductTermsForm">
      <ng-template matStepLabel>{{ 'labels.inputs.TERMS' | translate }}</ng-template>

      <LOSx-share-product-terms-step></LOSx-share-product-terms-step>
    </mat-step>

    <mat-step [stepControl]="shareProductSettingsForm">
      <ng-template matStepLabel>{{ 'labels.inputs.SETTINGS' | translate }}</ng-template>

      <LOSx-share-product-settings-step
        [shareProductsTemplate]="shareProductsTemplate"
      ></LOSx-share-product-settings-step>
    </mat-step>

    <mat-step [stepControl]="shareProductMarketPriceForm">
      <ng-template matStepLabel>{{ 'labels.inputs.MARKET PRICE' | translate }}</ng-template>

      <LOSx-share-product-market-price-step></LOSx-share-product-market-price-step>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>{{ 'labels.inputs.CHARGES' | translate }}</ng-template>

      <LOSx-share-product-charges-step
        [shareProductsTemplate]="shareProductsTemplate"
        [currencyCode]="shareProductCurrencyForm.get('currencyCode')"
      >
      </LOSx-share-product-charges-step>
    </mat-step>

    <mat-step [stepControl]="shareProductAccountingForm">
      <ng-template matStepLabel>{{ 'labels.inputs.ACCOUNTING' | translate }}</ng-template>

      <LOSx-share-product-accounting-step
        [shareProductsTemplate]="shareProductsTemplate"
        [accountingRuleData]="accountingRuleData"
        [shareProductFormValid]="shareProductFormValid"
      >
      </LOSx-share-product-accounting-step>
    </mat-step>

    @if (shareProductFormValid) {
      <mat-step state="preview" completed>
        <ng-template matStepLabel>{{ 'labels.inputs.PREVIEW' | translate }}</ng-template>
        <LOSx-share-product-preview-step
          [shareProductsTemplate]="shareProductsTemplate"
          [accountingRuleData]="accountingRuleData"
          [shareProduct]="shareProduct"
          [taskPermission]="'CREATE_SHAREPRODUCT'"
          (submitEvent)="submit()"
        >
        </LOSx-share-product-preview-step>
      </mat-step>
    }
  </mat-stepper>
</div>
